import { useContext } from "react";

import { RestrictedContext } from "@app/contexts/restricted/RestrictedContext";

const useRestricted = () => {
  return useContext(RestrictedContext);
};

export default useRestricted;
